import { render } from "./ProductCategoryComponent.vue?vue&type=template&id=25ea33a3"
import script from "./ProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductCategory/ProductCategoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25ea33a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25ea33a3', __exports__)) {
    api.reload('25ea33a3', __exports__)
  }
  
  module.hot.accept("./ProductCategoryComponent.vue?vue&type=template&id=25ea33a3", () => {
    api.rerender('25ea33a3', render)
  })

}


export default __exports__